import { render, staticRenderFns } from "./AddDiscounts.vue?vue&type=template&id=181e894f&scoped=true&"
import script from "./AddDiscounts.vue?vue&type=script&lang=js&"
export * from "./AddDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./AddDiscounts.vue?vue&type=style&index=0&id=181e894f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181e894f",
  null
  
)

component.options.__file = "AddDiscounts.vue"
export default component.exports